<template>
    <tr :key="endpoint.id" @click="clicked" style="cursor: pointer">
        <td class="text-left">
         {{ endpoint.name }}
        </td>
        <td class="text-left">
           {{ endpoint.url }}
        </td>
        <td class="text-left">
            <v-chip :color="getColor( endpoint.method )" dark>{{  endpoint.method }}</v-chip>
        </td>
        <td class="text-right">
            {{ endpoint.endpoint_flavor.name}}
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'endpoint-row',
        props: ['endpoint'],
        data () {
            return {
            }
        },
        computed: {

        },
        methods: {
            clicked () {
                this.$emit('click', this.endpoint)
            },
            scrollClicked () {
                this.$emit('action-click', this.device)
            },
            deleteClicked () {
                this.$emit('delete', this.device)
            },
            getColor (method) {
                if (method === 'GET') return 'orange'
                else return 'green'
            }
        }
    }
</script>

<style scoped>

</style>
